import { Component, OnInit } from '@angular/core';
import {gutil} from '../gutil';
import {Router} from '@angular/router';
import * as moment from 'moment';
import * as AOS from 'aos';
import { HttpClient } from '@angular/common/http';
import { faTimes ,faFileAlt , faHome , faBroom , faCouch , faPlug, faThumbsDown , faThumbsUp , faKey , faFaucet , faTools ,faCogs , faDownload , faCheckCircle, faExclamationCircle , faCheckSquare , faSpinner, faDotCircle, faUserSecret} from '@fortawesome/free-solid-svg-icons';

import { from } from 'rxjs';
@Component({
  selector: 'app-ownerdashboard',
  templateUrl: './ownerdashboard.component.html',
  styleUrls: ['./ownerdashboard.component.scss']
})
export class OwnerDashboardComponent implements OnInit {

  public user : any;
  public dispRentDetails : number = 0;
  public faDownload = faDownload;
  public faDotCircle = faDotCircle;
  public faCheckCircle = faCheckCircle;
  public faTimes = faTimes;
  public faSpinner = faSpinner;
  public faCheckSquare = faCheckSquare;
  public faThumbsUp = faThumbsUp;
  public faExclamationCircle = faExclamationCircle;
  public faThumbsDown = faThumbsDown;
  public faFileAlt = faFileAlt;
  public faKey = faKey;
  public faFaucet = faFaucet;
  public faTools = faTools;
  public faCogs = faCogs;
  public faBroom = faBroom;
  public faHome = faHome;
  public faCouch = faCouch;
  public faPlug = faPlug;
  public ownerData : any;
  public selectedPropName: string;
  public selectedPropData : any;
  public selectedPropTenantData: any;
  public ownerImgMedUrl : string;
  public ownerPropData: any;
  public properties : string;
  public ownerProperties : number;
  public YTDincome = 0;
  public YTDearning: string;
  public ownerDbScreen : string = "summary";
  public ownerTenants : any;
  public selectedPropId : number;
  public propTenantDocs = [];
  public conductedAudDtl = [];
  public totalAudits : number;
  public selectedAudit : any;
  public showAudits: number = 0;
  public selectedAudSection: string = 'auddetails';
  public selectedMonthSummary = [];
  public selectedMonthHealthStatus = [];
  public selectedAuditUrl : string;
  public phsoverall : string;
  public phsclean : string;
  public phsfurniture : string;
  public phsoverallremark : string;
  public phscleanremark : string;
  public phsfurnitureremark : string;
  public serviceRequestData = [];
  public srOwnerPay : any;
  public srYorPay: any;
  public srTenantPay: any;
  public srTotalPay: any;
  public tempSrTypeDetails = [];
  public srTypeDetails = [];
  public selectedSerType : number;
  public selectedSerName : string;
  public srAnalysisTable : any ;
  public srAnalysisCount : number;
  public srChartLabels:string[] = [];
  public srChartData:number[] = [];
  public srChartType:string = 'doughnut';
  public srChartProperty: any;
  public srColors = ['rgb(246, 104, 104)',
  'rgb(54, 162, 235)',
  'rgb(75, 192, 192)',
  'rgb(255, 205, 86)',
  'rgb(153, 102, 255)',
  'rgb(193, 154, 107)',
  'rgb(231,233,237)'];
  public srChartColors = 
  [
    {
      backgroundColor: ['rgb(246, 104, 104)',
                        'rgb(54, 162, 235)',
                        'rgb(75, 192, 192)',
                        'rgb(255, 205, 86)',
                        'rgb(153, 102, 255)',
                        'rgb(193, 154, 107)',
                        'rgb(231,233,237)']
    }
  ];
  public rentData : any;
  public rentMeterType : string = 'semi';
  public rentMeterLabel : string = 'YTD Rent-O-Meter';
  public rentMeterValue : any;
  public rentMeterThresholds = {
    '0' : {color: 'coral'},
    '25' : {color: 'orange'},
    '75' : {color: 'rgb(86, 191, 54)'}
  }
  public selectedAuditMonthId : number;
  public rentLineChartLabels: string[] = [];
  public rentLineChartData:any[] = [
    {data: [], label: 'Series A'},
    {data: [], label: 'Series B'}
  ];
  public rentLineChartLegend:boolean = true;
  public rentLineChartType:string = 'line';
  public lineChartColors:Array<any> = [
    { // dark grey
      backgroundColor: 'rgba(249,227,22,0.2)',
      borderColor: 'rgba(249,227,22,1)',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
    { // grey
      backgroundColor: 'rgba(173,216,230,0.2)',
      borderColor: 'rgba(32,178,170,1)',
      pointBackgroundColor: 'rgba(32,178,170,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ]
  public lineChartOptions: any = {
    responsive: true,
    animation: {
        onComplete: function () {
            var chartInstance = this.chart,
                ctx = chartInstance.ctx;

            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            this.data.datasets.forEach(function (dataset, i) {
                var meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach(function (bar, index) {
                    var data = dataset.data[index];
                    ctx.fillText(data, bar._model.x, bar._model.y - 5);
                });
            });
        }
    }
 };
 public chartTypes : any;
 public selectedRentChart : number = 0;
 public rentDetailsData : any;
 public sreqTypeData = [];
 public onboardingData : any;
 public onboardingStep : number = 1;
 public ownerDocuments: number;
 public ownerDocData = [];
 public ownerPropMaintain : number;
 public ownerPropMaintainData : any;
 public goLiveDateCheck: number;
 public goLiveDate : string;

 public onboardingLoading : number;
 public goLiveDateEn : any;
 public showSRImg : boolean = false;
 public onboardingTenantLoading : boolean = true;
 public onboardingAuditLoading : boolean = true;
 public onboardingSerLoading : boolean = true;
public checkRentMeter: number;
 public onboardingRentLoading: boolean = true;

  constructor(private http:HttpClient,private router: Router) {
      this.user = gutil.user;
   }

  ngOnInit(): void {
    window.scrollTo(0,0);
    // this.fetchOwnerDetails();
    this.fetchPropertyDetails(this.user.id);
    this.ownerDbScreen = 'summary';
    this.chartTypes = gutil.chartTypes;
    this.selectedRentChart = 0;
    AOS.init();
    if(gutil.user.id == 1412){
      this.fetchOwnerDetails();
    }
    
  }

  public changeSection(section : string){
    this.ownerDbScreen = section;
    this.conductedAudDtl = [];
    if(section == 'tenants'){
      this.fetchPropertyTenants();
    }
    if(section == 'audits'){
      this.fetchAuditDetails(this.selectedPropId);
    }
    if(section == 'srequests'){
      this.fetchSerRequestData(this.selectedPropId);
    }
    if(section == 'rentmeter'){
      this.fetchRentDetails(this.selectedPropId , 'month' , 'chart');
    }
    if(section == 'onboarding'){
      this.fetchOnboardingData(this.selectedPropId);
    }
  }

  public changeProperty(pid : number ){
    this.ownerDbScreen = 'tenants';
    this.selectedPropId = pid;
    // this.conductedAudDtl = [];
    this.fetchPropertyTenants();
    
  }

  public changeProp(value : any){
    console.log(value);
    this.selectedPropId = value;
    this.selectedRentChart = 0;
    if(this.ownerDbScreen == 'tenants'){
      this.fetchPropertyTenants();
    }
    if(this.ownerDbScreen == 'audits'){
      this.fetchAuditDetails(value);
    }
    if(this.ownerDbScreen == 'srequests'){
      this.fetchSerRequestData(value);
    }
    if(this.ownerDbScreen == 'rentmeter'){
      this.fetchRentDetails(value , 'month' , 'chart');
    }
    if(this.ownerDbScreen == 'onboarding'){
      this.fetchOnboardingData(value);
    }
  }

  public fetchOnboardingData(pid : number){
    this.onboardingLoading = 0;
    
    this.http.get(gutil.devapiUrl + '/api/v1/owner/onboard?api_token=' + this.user.api_token).subscribe((data : any) => {
      this.onboardingData = data.obj;
      this.onboardingLoading = 1;
      
    })

    this.http.get(gutil.devapiUrl + '/api/v1/owner/maintenance/' + pid + '?api_token=' + this.user.api_token).subscribe((data: any) => {
        this.ownerPropMaintainData = data.obj;
        this.goLiveDate = this.ownerPropMaintainData[0].golivedate;
        this.goLiveDateEn = moment(this.ownerPropMaintainData[0].golivedate).format('LL');
        if(this.goLiveDate != undefined || this.goLiveDate != "0000-00-00" || this.goLiveDate != null){
          this.goLiveDateCheck = 1;
        }
        else{
          this.goLiveDateCheck = 0;
        }
        let length = this.ownerPropMaintainData.length;
        for(let m = 0 ; m < length ; m++){
          if(this.ownerPropMaintainData[m].percentage == 100){
            this.ownerPropMaintain = 1;
          }else{
            this.ownerPropMaintain = 1;
            break;
          }
        }
    })
    this.http.get(gutil.devapiUrl + '/api/v1/documents/info/' + this.user.id + "?api_token=" + this.user.api_token).subscribe((data : any) => {
      let temp = data.data;
      let length = data.total;

      this.ownerDocData = [];
      for(let doc = 0 ; doc < length ; doc++){
        if(temp[doc].type !== 'lease' &&   temp[doc].type !== 'saledeed'){
          this.ownerDocData.push(temp[doc]);
        }
      }

      for(let i = 0 ; i < this.ownerDocData.length ; i++){
        if(this.ownerDocData[i].status == 10){
            this.ownerDocuments = 1;
        }else{
          this.ownerDocuments = 0;
          break;
        }
      }
      
    })
    
  }
   public onboardingStepDetail(step: number){
      switch (step){
        case 1:
          this.onboardingStep = step;
          break;
        case 2: 
          this.onboardingStep = step;
          
          break;
        case 3: 
          this.onboardingStep = step;
          break;
        case 4: 
          this.onboardingStep = step;
          break;
        case 5: 
          this.onboardingStep = step;
          if(this.goLiveDate != undefined || this.goLiveDate != "0000-00-00" || this.goLiveDate != null){
            this.goLiveDateCheck = 1;
          }
          else{
            this.goLiveDateCheck = 0;
          }
          break;
        default: 
          this.onboardingStep = 1;
      }
   }
  // fetch owner details. 
  public fetchOwnerDetails(){
    this.http.get(gutil.devapiUrl + '/api/v1/user/info?api_token=' + this.user.api_token).subscribe((data:any) => {
      this.ownerData = data.obj;
      for(let img = 0 ; img < this.ownerData.images.length; img ++ ){
        if(this.ownerData.images[img].size == "thb"){
          this.ownerImgMedUrl = this.ownerData.images[img].url;
        }
      }
    })
  }
  public INRFormat(amount : any){
    if (! isNaN(amount)) {
      var currencySymbol = '₹ ';
      //var output = Number(amount).toLocaleString('en-IN');   <-- This method is not working fine in all browsers!
      var result = amount.toString().split('.');

      var lastThree = result[0].substring(result[0].length - 3);
      var otherNumbers = result[0].substring(0, result[0].length - 3);
      if (otherNumbers != '')
          lastThree = ',' + lastThree;
      var output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

      if (result.length > 1) {
          output += "." + result[1];
      }

      return currencySymbol + output;
  }
  }
  //fetch property details of owner
  public fetchPropertyDetails(owner_id: number){
    this.http.get(gutil.devapiUrl + '/api/v1/property/gettenant/owner/' + owner_id + "?api_token=" + this.user.api_token).subscribe((data: any) => {
      this.ownerPropData = data.data;
      if(data.total > 0){
        this.ownerProperties = 1;
        this.properties = "We are currently managing " + data.total + " of your properties." ;
        for(let p = 0 ; p < this.ownerPropData.length ; p++){
          if(this.ownerPropData[p].status == "blocked"){
            let temp = 0 ;
            temp = this.ownerPropData.splice(p , 1); 
            this.ownerPropData = this.ownerPropData.concat(temp);
          }
          this.http.get(gutil.devapiUrl + '/api/v1/spendanalysis/getdata/' + this.ownerPropData[p].id + "?api_token=" + this.user.api_token).
            subscribe((data: any) => {
                  this.YTDincome += parseInt(data.data[0].ytdincome); 
                  this.YTDearning = this.INRFormat(this.YTDincome);
                  // this.ownerPropData.YTDincome = this.YTDincome;
                  let temp1 = this.INRFormat(data.data[0].ytdincome);
                  let temp2 = this.INRFormat(data.data[0].srtotalbill);
                  this.ownerPropData[p].ytdIncome = temp1;
                  this.ownerPropData[p].srCount = data.data[0].srcount;
                  this.ownerPropData[p].srSpent = temp2;
                  this.ownerPropData[p].auditCount = data.data[0].auditcount;
                  this.ownerPropData[p].totalActiveTenants = this.ownerPropData[p].propertyusers.length;
                  this.ownerPropData[p].totalTenants = this.ownerPropData[p].totalrooms * 2;
          })
          
          this.http.get(gutil.devapiUrl + '/api/w/v1/schedule/visit/counts/' + this.ownerPropData[p].id).subscribe((data : any) => {
            this.ownerPropData[p].totalSiteVisits = data.obj;
          })
        }
      }else{
          this.ownerProperties = 0;
          
        }
      
    })
  }

  public fetchPropertyTenants(){
    this.onboardingTenantLoading = true;
    let dataLength = this.ownerPropData.length;
    for(let i = 0; i < dataLength; i++){
      if(this.ownerPropData[i].id == this.selectedPropId){
        this.selectedPropData = this.ownerPropData[i];
        this.selectedPropTenantData = this.ownerPropData[i].propertyusers;
      }
      if( i == dataLength - 1){
        this.onboardingTenantLoading = false;
      }
    }
  }

  public openAggrement(uid : number){
    let temp = '';
    this.http.get(gutil.devapiUrl + '/api/v1/documents/owner/info/' + this.user.id + "?api_token=" + this.user.api_token).
      subscribe((data : any) => {
        for(let a in data.data){
          if(data.data[a].user_id == uid && data.data[a].type == 'rent'){
            temp = data.data[a].url;
          }
        }

        window.open(temp , "_blank");
      })
  }
  public openDocs(url : string){
    window.open(url , "_blank");
  }

  public fetchAuditDetails(propId : number){
    this.onboardingAuditLoading = true;
    this.conductedAudDtl = [];
    this.http.get(gutil.devapiUrl + '/api/v1/audit/getschedule/' + propId + '?api_token=' + this.user.api_token).
      subscribe((data: any) => {
        for(let aud in data.obj){
          if(data.obj[aud].audit_id != null){
            data.obj[aud].audMonth = data.obj[aud].month.split(" ")[0];
            data.obj[aud].audYear = data.obj[aud].month.replace(data.obj[aud].audMonth + ' ', '');
            this.conductedAudDtl.push(data.obj[aud]);
            
          }
        }
        this.totalAudits = this.conductedAudDtl.length;
        this.onboardingAuditLoading = false;
      })
  }

  public scrollRight() {
    let content = document.getElementById('aud_month_list');
    this.slideScroll(content,'right',25,150,10);
  }
  public scrollLeft() {
    let content = document.getElementById('aud_month_list');
    this.slideScroll(content,'left',25,150,10);
  }

  public slideScroll(element : any,direction: string,speed: number,distance: number,step: number){
    let scrollAmount = 0;
    let slideTimer = setInterval(function(){
      if(direction == 'left'){
        element.scrollLeft -= step;
      }else{
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if(scrollAmount >=distance ){
        window.clearInterval(slideTimer);
      }
    }, speed)
  }
  public fetchAudit(aid : number){
    this.selectedAuditMonthId= aid;
    let tempSummary = [];
    let tempHealth = [];
    let ii = 0;
    let jj = 0;
    this.showAudits = 1;
    this.selectedAudit = [];
    for(let aud in this.conductedAudDtl){
      if(this.conductedAudDtl[aud].id == aid){
        this.selectedAudit = this.conductedAudDtl[aud];
      }
    }
    tempSummary = this.selectedAudit.auditdata.newcomment;
    tempHealth = this.selectedAudit.auditdata;
    this.selectedAuditUrl = this.selectedAudit.auditdata.url;
    
    for(let x in tempSummary){
      this.selectedMonthSummary[ii] = tempSummary[x];
      this.selectedMonthSummary[ii]['category'] = x;
      this.selectedMonthSummary[ii]['status'] = tempSummary[x].status;
      let tempComment = tempSummary[x].newcomment;
      this.selectedMonthSummary[ii]['newcomment'] = tempComment.replaceAll('&nbsp;' , '');
      ii++;
    }

    
    this.selectedMonthHealthStatus.push(tempHealth);
    for(let h in this.selectedMonthHealthStatus){
      if(this.selectedMonthHealthStatus[h].phs_overall == 1 || this.selectedMonthHealthStatus[h].phs_overall == 0 ){
        this.phsoverall = 'Good';
      }else if(this.selectedMonthHealthStatus[h].phs_overall == 2){
        this.phsoverall = 'Fair';
      }else{
        this.phsoverall = 'Poor';
      }
      if(this.selectedMonthHealthStatus[h].phs_clean == 1 || this.selectedMonthHealthStatus[h].phs_clean == 0 ){
        this.phsclean = 'Good';
      }else if(this.selectedMonthHealthStatus[h].phs_clean == 2){
        this.phsclean = 'Fair';
      }else{
        this.phsclean = 'Poor';
      }
      if(this.selectedMonthHealthStatus[h].phs_furniture == 1 || this.selectedMonthHealthStatus[h].phs_furniture == 0 ){
        this.phsfurniture = 'Good';
      }else if(this.selectedMonthHealthStatus[h].phs_furniture == 2){
        this.phsfurniture = 'Fair';
      }else{
        this.phsfurniture = 'Poor';
      }
      

      if( (this.selectedMonthHealthStatus[h].phs_overall == 1 || this.selectedMonthHealthStatus[h].phs_overall == 0)  && (this.selectedMonthHealthStatus[h].phs_overallremark == "" || this.selectedMonthHealthStatus[h].phs_overallremark == null || this.selectedMonthHealthStatus[h].phs_overallremark == undefined) ){
        this.phsoverallremark = "Everything is in good condition.";
      }else{
        this.phsoverallremark = this.selectedMonthHealthStatus[h].phs_overallremark;
      }
      if( (this.selectedMonthHealthStatus[h].phs_clean == 1 || this.selectedMonthHealthStatus[h].phs_clean == 0)  && (this.selectedMonthHealthStatus[h].phs_cleanremark == "" || this.selectedMonthHealthStatus[h].phs_cleanremark == null || this.selectedMonthHealthStatus[h].phs_cleanremark == undefined) ){
        this.phscleanremark = "Everything is in good condition.";
      }else{
        this.phscleanremark = this.selectedMonthHealthStatus[h].phs_cleanremark;
      }
      if( (this.selectedMonthHealthStatus[h].phs_furniture == 1 || this.selectedMonthHealthStatus[h].phs_furniture == 0)  && (this.selectedMonthHealthStatus[h].phs_furnitureremark == "" || this.selectedMonthHealthStatus[h].phs_furnitureremark == null || this.selectedMonthHealthStatus[h].phs_furnitureremark == undefined) ){
        this.phsfurnitureremark = "Everything is in good condition.";
      }else{
        this.phsfurnitureremark = this.selectedMonthHealthStatus[h].phs_furnitureremark;
      }
    }
  }


  public changeAuditSection(section : string){
    this.selectedAudSection = section;
  }

  public fetchSerRequestData(propid : number){
    this.onboardingSerLoading = true;
    this.srTypeDetails = [];
    this.http.get(gutil.devapiUrl + '/api/v1/spendanalysis/getdata/' + propid + '?api_token=' + this.user.api_token).subscribe((data : any) => {
        // this.serviceRequestData = data.data;
        if(data.data[0].srcount > 0){
          this.srOwnerPay = this.INRFormat(data.data[0].opaid);
          this.srTenantPay = this.INRFormat(data.data[0].tpaid);
          this.srYorPay = this.INRFormat(data.data[0].yorpaid);
          this.srTotalPay = data.data[0].totalamnt;
          for(let sr in data.data){
            this.serviceRequestData[sr] = data.data[sr];
            this.serviceRequestData[sr]['srcount'] = data.data[sr].srcount;
            this.serviceRequestData[sr]['svcount'] = data.data[sr].svcount;
            this.serviceRequestData[sr]['totalamnt'] = data.data[sr].totalamnt;
            this.serviceRequestData[sr]['tpaid'] = data.data[sr].tpaid;
            this.serviceRequestData[sr]['opaid'] = data.data[sr].opaid;
            this.serviceRequestData[sr]['yorpaid'] = data.data[sr].yorpaid;
            this.serviceRequestData[sr]['propname'] = data.data[sr].propname;
            this.serviceRequestData[sr]['srdetails']= data.data[sr].srdetails;
            this.serviceRequestData[sr]['occupancy'] = data.data[sr].occupancy;
            this.serviceRequestData[sr]['auditcount'] = data.data[sr].auditcount;
            this.serviceRequestData[sr]['occupiedrooms'] = data.data[sr].occupiedrooms;
            this.serviceRequestData[sr]['totalbeds'] = data.data[sr].totalbeds;
            this.serviceRequestData[sr]['totalrooms'] = data.data[sr].totalrooms;
            this.serviceRequestData[sr]['vacentbeds'] = data.data[sr].vacentbeds;
            this.serviceRequestData[sr]['ytdincome'] = data.data[sr].ytdincome;
            this.serviceRequestData[sr]['financial201617'] = data.data[sr].financial201617;
            this.serviceRequestData[sr]['financial201718'] = data.data[sr].financial201718;
            this.serviceRequestData[sr]['financial201819'] = data.data[sr].financial201819;
            this.serviceRequestData[sr]['totaltenants'] = data.data[sr].totaltenants;
          }
          
          let tempSerDetails = this.serviceRequestData[0].srdetails;
          let tempSerDetails2 = [];
          let i = 0;
          for(let x in tempSerDetails){
            tempSerDetails2[i] = tempSerDetails[x];
            tempSerDetails2[i]['type'] = x;
            tempSerDetails2[i]['billamnt'] = this.INRFormat(tempSerDetails[x].billamount);
            tempSerDetails2[i]['percentage'] = (tempSerDetails[x].fcount/this.serviceRequestData[0].srcount)*100;
            i++;
          }
          if(tempSerDetails2.length > 0){
            this.tempSrTypeDetails = tempSerDetails2;
          }else{
            this.tempSrTypeDetails = undefined;
          }

          this.srTypeDetails = this.tempSrTypeDetails.sort(this.compare);
          // console.log(this.srTypeDetails);
          this.onboardingSerLoading = false;
        }else{
          this.onboardingSerLoading = false;
        }
    })

    this.http.get(gutil.devapiUrl + '/api/v1/sranalysis/getdata/' + propid + "?api_token=" + this.user.api_token).subscribe((data: any) => {
        this.srAnalysisTable = data.data;
        this.srAnalysisCount = this.srAnalysisTable.length;
        this.srChartLabels = this.srAnalysisTable[0].type;
        this.srChartData = this.srAnalysisTable[0].cnt;
        this.srChartProperty = this.srAnalysisTable[0].id + " - " + this.srAnalysisTable[0].propname;
        
    })
  }

  public showRequests(type: number , name: string){
    this.selectedSerType = type;
    this.selectedSerName = name;
    
    this.sreqTypeData = [];
    this.http.get(gutil.devapiUrl + '/api/v1/services/info/' + this.user.id + '?api_token=' + this.user.api_token).subscribe((data: any) =>{
      for(let x in data.data){
        if(data.data[x].category == 1 && data.data[x].type == type && data.data[x].property_id == this.selectedPropId){
          data.data[x].details = data.data[x].detail.replace(/(<([^>]+)>)/gi, "");
          data.data[x].raised_on = moment(data.data[x].created_at).format('LL');
          data.data[x].closed_on = moment(data.data[x].closure_date).format('LL');
          this.sreqTypeData.push(data.data[x]);
        }
      }
    })
  }

  public compare(a, b) {
    if (a.typeid < b.typeid){
      return -1;
    }
    if (a.typeid > b.typeid){
      return 1;
    }
    return 0;
  }

  public chartClicked(e:any):void {
      console.log(e);
    }

    public chartHovered(e:any):void {
      console.log(e);
    }

    public fetchRentDetails(propid: number , duration: string , type: string){
      this.onboardingRentLoading = true;
      console.log(propid + duration + type);
      this.http.get(gutil.devapiUrl + '/api/v1/rentometer/get/' + propid + '?api_token=' + this.user.api_token).subscribe((data : any) => {
        if(data.obj == undefined || data.obj != -1){
          this.rentMeterValue = data.data[0].finalpercentage;
          this.rentData = data.data[0];
          this.checkRentMeter = 1;
          this.fetchRentChartData(propid , duration , type);
        }
        if(data.obj == -1){
          this.checkRentMeter = 0;
          this.onboardingRentLoading = false;
        }
        // console.log(this.rentData.finalpercentage);
      })

    }

    public fetchRentChartData(propid: number , duration: string , type: string){
      this.http.get(gutil.devapiUrl + '/api/v1/rentometer/getprop/' + propid + '/' + duration + '/' + type + '?api_token=' + this.user.api_token).
          subscribe((data: any) => {
              if(type == 'chart'){
                if(duration == 'month'){
                    this.rentLineChartLabels = data.data.chartmonth_yr;
                    this.dispRentDetails = 1;
                }
                else if(duration == 'year'){
                  this.rentLineChartLabels = data.data.chartmonth_yr;
                  this.dispRentDetails = 2 ;
                }
                this.rentLineChartData = [
                  {data: data.data.chartowner_rent, label: 'Committed Rent'},
                  {data: data.data.chartpropertypayamount, label: 'Received Rent'}
                ];
              }
              else{
                    this.rentDetailsData = data.data; 
                    console.log(this.rentDetailsData);
                  
                    this.dispRentDetails = 3;
              }
              
          })
          this.onboardingRentLoading = false;
    }

    public changeRentDetailChart(value: number){
      console.log(value);
      if(value == 1){
        this.fetchRentChartData(this.selectedPropId , 'month' , 'chart');
      }
      else if(value == 2){
        this.fetchRentChartData(this.selectedPropId , 'year' , 'chart');
      }
      else{
        this.fetchRentChartData(this.selectedPropId , 'month' , 'details');
      }
    }

    public showSerReqImg(sid : number){
      this.showSRImg = !this.showSRImg;
    }
}
